import { render, staticRenderFns } from "./ScoutingReportScoreChip.vue?vue&type=template&id=77d51348&scoped=true&"
import script from "./ScoutingReportScoreChip.vue?vue&type=script&lang=ts&"
export * from "./ScoutingReportScoreChip.vue?vue&type=script&lang=ts&"
import style0 from "./ScoutingReportScoreChip.vue?vue&type=style&index=0&id=77d51348&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d51348",
  null
  
)

export default component.exports